import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Models
import { scenarioTriggersFromType } from 'models/antipassback';
// Custom
import { scenarioDataShape } from 'constants/PropTypesShapes';
import Callout from 'components/misc/Callout';
import AntipassbackScenarioTriggerItem from './AntipassbackScenarioTriggerItem';

const AntipassbackScenarioTriggers = ({ scenarios }) => {
  if (scenarios) {
    // Get input and output scenario triggers
    const inputScenarioTriggers = scenarioTriggersFromType(scenarios, 'input');
    const outputScenarioTriggers = scenarioTriggersFromType(scenarios, 'output');

    return (
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col-12">
              <Callout>
                <LocalizedMessage id="info.inputTriggerMeans" />
              </Callout>
            </div>
            {_map(inputScenarioTriggers, (scenarioTrigger) => (
              <div key={scenarioTrigger.id} className="col-12">
                <AntipassbackScenarioTriggerItem scenarioTrigger={scenarioTrigger} />
              </div>
            ))}
            {_isEmpty(inputScenarioTriggers) && (
              <div className="col-12 pt-3 pl-4">
                <em><LocalizedMessage id="info.noScenarioTrigger" /></em>
              </div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-6 pt-3 pt-md-0">
          <div className="row">
            <div className="col-12">
              <Callout>
                <LocalizedMessage id="info.outputTriggerMeans" />
              </Callout>
            </div>
            {_map(outputScenarioTriggers, (scenarioTrigger) => (
              <div key={scenarioTrigger.id} className="col-12">
                <AntipassbackScenarioTriggerItem scenarioTrigger={scenarioTrigger} />
              </div>
            ))}
            {_isEmpty(outputScenarioTriggers) && (
              <div className="col-12 pt-3 pl-4">
                <em><LocalizedMessage id="info.noScenarioTrigger" /></em>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

AntipassbackScenarioTriggers.propTypes = {
  scenarios: PropTypes.arrayOf(scenarioDataShape).isRequired,
};

module.exports = AntipassbackScenarioTriggers;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/antipassbacks/AntipassbackScenarioTriggers.js